import SelectBox from "devextreme-react/select-box";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "devextreme-react/popup";
import { fire } from "../../../api/firebaseEnv";
import { InfoCircle } from "react-bootstrap-icons"; // al inicio del archivo
import * as EstabService from "../../../api/establishment";
import * as ReportsService from "../../../api/reports";
import * as DinamicQueries from "../../../api/DinamicsQuery";

import DataGrid, {
  Pager,
  Column,
  Paging,
  Export,
  FilterRow,
  HeaderFilter,
  Toolbar,
  Item,
  ColumnChooser,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";
import { ArrowLeftCircle } from "react-bootstrap-icons";
import DateBox from "devextreme-react/date-box";
import CellRenderEstatus from "../../../components/Grids/estatus-grid/estatus-grid";
import CellRenderIconsGrids from "../../../components/Grids/icons-grid/icons-grid";
import ScrollView from "devextreme-react/scroll-view";
import Moment from "moment";
import * as FormService from "../../../api/forms";
import moment from "moment";

export default function EditForm() {
  const history = useNavigate();
  const allowedPageSizes = [8, 12, 20];
  const todayDate = new Date().toLocaleDateString();
  const [forms, setForms] = useState([]);
  const [filters, setFilters] = useState({
    fecha_Desde: todayDate,
    fecha_Hasta: todayDate,
  });
  const [showPopupfiltro, setShowPopupfiltro] = useState(false);
  const [showPopupDelete, setShowPopupDelete] = useState(false);
  const [FormDelete, setFormDelete] = useState({});
  const [Clientes, setClientes] = useState([]);
  const [Regiones, setRegiones] = useState([]);
  const initialState = {
    cliente: "",
    region: "TODAS LAS REGIONES",
    fechaInicio: new Date(new Date().setDate(new Date().getDate() - 7)),
    fechaFinal: new Date(),
  };
  const [FiltrosReporte, setFiltrosReporte] = useState(initialState);
  const [fechaInicial, setfechaInicial] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
  );
  const [FechaFinal, setFechaFinal] = useState(new Date());
  const [showPopupEstabId, setShowPopupEstabId] = useState(false);
  const [estabIdSelected, setEstabIdSelected] = useState(null);
  const [formSeleccionado, setFormSeleccionado] = useState(null);
  const [establecimientos, setEstablecimientos] = useState([]);
  const [regiones, setRegion] = useState([]);
  const [clientes, setCliente] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [regionSeleccionada, setRegionSeleccionada] = useState(""); // valor seleccionado
  const [establecimientoSeleccionado, setEstablecimientoSeleccionado] =
    useState(null);
  // ...otros estados...

  let user = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    setClientes(user.cliente);
    setRegiones(user.region);
    // EstabService.getEstablecimientos()
    //   .then((resp) => {
    //     console.log("Respuesta de getEstablecimientos:", resp); // <-- Aquí el console
    //     if (resp && resp.data) {
    //       setEstablecimientos(resp.data);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error al obtener establecimientos:", error);
    //   });

    ReportsService.getRegion()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getRegion ~ resp:", resp.data);
        setRegion(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));

    ReportsService.getClients()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getclientes ~ resp:", resp.data);
        setCliente(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));

    DinamicQueries.getData("getAllEstablishment", "EstablecimientosNuevos/")
      .then((resp) => {
        console.log("🚀 ~ DinamicQueries.getData ~ resp:", resp.data);
        setEstablecimientos(resp.data);
      })
      .catch((e) => {});
    // FormService.getSavedForms(filters).then(result => {
    //     console.log("🚀 ~ file: editForm.js:29 ~ FormService.getSavedForms ~ result:", result)
    //     if(result.status == 200 && result.data.msg == true){
    //         setForms(result.data.data);
    //     }else{
    //         console.log('Ha ocurrido un error ');
    //     }
    // })
  }, []);

  const establecimientosFiltrados = establecimientos.filter(
    (e) => e.nombre_region === regionSeleccionada
  );

  const openEditPopup = (data) => {
    console.log("Editando Popup ", data);
    localStorage.setItem("SelectedForm", JSON.stringify([data]));
    localStorage.setItem("Actualizar", "Yes");
    history("/Form");
  };

  const openDeletePopup = (data) => {
    console.log("Eliminando Popup ", data);
    setShowPopupDelete(true);
    setFormDelete(data);
  };

  const hideDeletePopup = () => {
    setShowPopupDelete(false);
    setFormDelete({});
  };

  const goBack = () => {
    history("/formularios");
  };

  const openFiltrarPopup = (uid) => {
    setShowPopupfiltro(true);
  };

  const hidefiltroPopup = () => {
    setShowPopupfiltro(false);
    setFiltrosReporte(initialState);
  };

  const onDelete = () => {
    let data = {
      fecha_eliminado: moment().format(),
      formulario_eliminado: {
        form_key: FormDelete.key,
        establecimiento: FormDelete.establecimiento,
        fecha_formulario: FormDelete.fecha_Formulario,
        promotor: FormDelete.promotor,
      },
      nombre_usuario: `${user.nombre} ${user.apellido}`,
      user_key: user.uid,
    };

    console.log(data);
    fire
      .collection("Formularios_Eliminados")
      .add(data)
      .then((res) => {
        console.log(res.id);
        fire
          .collection("Formularios_Llenos")
          .doc(data.formulario_eliminado.form_key)
          .delete()
          .then(() => {
            console.log("Formulario Eliminado");
            hideDeletePopup();
            setForms(); // Cierra el popup después del borrado
            alert("Formulario eliminado con éxito"); // Notificación de éxito
          });
      });
  };

  const OnSubmit = () => {
    const fechaInicialReport = Moment(FiltrosReporte.fechaInicio).format(
      "YYYY-MM-DD"
    );
    console.log(
      "🚀 ~ file: editForm.js:86 ~ OnSubmit ~ fechaInicialReport:",
      fechaInicialReport
    );
    const fechaFinalReport = Moment(FiltrosReporte.fechaFinal).format(
      "YYYY-MM-DD"
    );

    console.log(
      "🚀 ~ file: editForm.js:90 ~ OnSubmit ~ fechaFinalReport:",
      fechaFinalReport
    );

    console.log(FiltrosReporte);

    const searchData = {
      cliente: FiltrosReporte.cliente,
      region: FiltrosReporte.region,
      fecha_Desde: fechaInicialReport,
      fecha_Hasta: fechaFinalReport,
    };

    FormService.getSavedForms(searchData).then((result) => {
      console.log(
        "🚀 ~ file: editForm.js:29 ~ FormService.getSavedForms ~ result:",
        result
      );
      if (result.status === 200 && result.data.msg === true) {
        console.log(result.data.data);
        setForms(result.data.data);
        hidefiltroPopup();
        setFiltrosReporte(initialState);
      } else {
        console.log("Ha ocurrido un error ");
      }
    });
  };

  const CellRenderIconsGrids = (
    data,
    openEditPopup,
    openDeletePopup,
    openEstabIdPopup
  ) => (
    <div style={{ display: "flex", gap: "8px" }}>
      {/* Iconos existentes */}
      <span
        onClick={() => openEditPopup(data.data)}
        style={{ cursor: "pointer" }}
      >
        ✏️
      </span>
      <span
        onClick={() => openDeletePopup(data.data)}
        style={{ cursor: "pointer" }}
      >
        🗑️
      </span>
      {/* Nuevo icono para mostrar el ID del establecimiento */}
      <span
        onClick={() => {
          openEstabIdPopup(data.data);
          setRegionSeleccionada("");
          setEstablecimientoSeleccionado("");
        }}
        style={{ cursor: "pointer" }}
      >
        <InfoCircle />
      </span>
    </div>
  );

  const openEstabIdPopup = (data) => {
    console.log("Abriendo popup de ID de establecimiento", data.key);
    setEstabIdSelected(data.key); // Usa el campo que sea el ID real del formulario
    setFormSeleccionado(data);    // Guardar todo el formulario para enviarlo al backend
    setShowPopupEstabId(true);
  };

  const ModifyEstablecimientos = async () => {
    // Busca el establecimiento seleccionado
    const selectedEstabObj = establecimientos.find(
      (e) => e.nombre_establecimiento === establecimientoSeleccionado
    );

    if (!selectedEstabObj) {
      alert("Debes seleccionar un establecimiento válido.");
      return;
    }

    // Construir formulario actualizado manteniendo fechas y demás campos
    const formActualizado = {
      ...formSeleccionado,
      establecimiento: selectedEstabObj.nombre_establecimiento,
      ciudad: selectedEstabObj.nombre_ciudad,
      cod_est: selectedEstabObj.ID,
      key_est: selectedEstabObj.key,
    };

    try {
      const resp = await FormService.updateEstablishmentForm(formActualizado);

      if (resp?.data?.msg) {
        alert("Establecimiento Modificado");
        setShowPopupEstabId(false);
        setForms(); // Si quieres, aquí podrías volver a llamar a OnSubmit() para refrescar la lista
      } else {
        alert("Error al modificar el establecimiento");
      }
    } catch (error) {
      console.error("Error actualizando el establecimiento desde API:", error);
      alert("Error al modificar el establecimiento");
    }
  };

  return (
    <div id="container" style={{ height: "80%" }}>
      <div className="d-flex">
        <div className="header-grid-title100">
          <h5 className="content-block titleCliente mb-3 mt-4">
            <ArrowLeftCircle onClick={goBack} className="btn-back mr-2" />
            Edición de Formularios
          </h5>
        </div>
      </div>
      <div className="edit-form-container h-100">
        <div>
          <Button
            className="btn btn-primary mt-2 mb-2"
            icon="filter"
            text="Filtros"
            onClick={openFiltrarPopup}
          />
        </div>
        <DataGrid
          className={"dx-card wide-card form-edit-grid h-75"}
          dataSource={forms}
          showBorders={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          rowAlternationEnabled={true}
          columnAutoWidth={true}
          wordWrapEnabled={true}
          keyExpr="fecha_Formulario"
        >
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" />
          <FilterRow visible={true} />
          <Paging defaultPageSize={20} />
          <Pager
            showPageSizeSelector={true}
            showInfo={true}
            allowedPageSizes={allowedPageSizes}
          />
          <HeaderFilter visible={true} />

          <Column caption={"Formulario"} dataField={"nombre"} width={150} />
          <Column dataField={"cliente"} caption={"Cliente"} dataType="string" />
          <Column
            dataField={"establecimiento"}
            caption={"Establecimiento"}
            dataType="string"
            width={250}
          />
          <Column
            dataField={"promotor"}
            caption={"Promotor"}
            dataType="string"
          />
          <Column
            dataField={"fecha_Sincronizado"}
            caption={"Fecha"}
            dataType="string"
          />
          <Column dataField={"version"} caption={"Versión"} dataType="string" />
          {/* <Column
                        dataField={"estatus"}
                        caption={"Editado"}
                        dataType="string"
                        cellRender={CellRenderEstatus}
                    /> */}
          <Column
            width={80}
            caption=""
            allowSorting={false}
            cellRender={(data) =>
              CellRenderIconsGrids(
                data,
                openEditPopup,
                openDeletePopup,
                openEstabIdPopup
              )
            }
            name="renderEstab"
          />
          <Export enabled={true} />
        </DataGrid>

        <Popup
          width={"700px"}
          height={"500px"}
          visible={showPopupfiltro}
          onHiding={hidefiltroPopup}
          showTitle={true}
          title="Filtrar informacion"
          showCloseButton={true}
        >
          <ScrollView width="100%" height="100%">
            <div className="form-container text-center">
              <div className="dx">
                <div className="seles">
                  <SelectBox
                    className="SelectBoxC mb-4"
                    placeholder="Seleccione un cliente"
                    label="Cliente"
                    searchEnabled={true}
                    dataSource={Clientes}
                    defaultValue={FiltrosReporte.cliente}
                    value={FiltrosReporte.cliente}
                    onValueChanged={(e) =>
                      setFiltrosReporte({ ...FiltrosReporte, cliente: e.value })
                    }
                  />
                </div>
              </div>

              <div className="dx">
                <div className="">
                  <SelectBox
                    className="SelectBoxR mb-4"
                    placeholder="Seleccione una región"
                    label="Región"
                    searchEnabled={true}
                    dataSource={Regiones}
                    onValueChanged={(e) =>
                      setFiltrosReporte({ ...FiltrosReporte, region: e.value })
                    }
                    defaultValue={FiltrosReporte.region}
                    value={FiltrosReporte.region}
                    style={{}}
                  />
                </div>
              </div>
              <div className="dx">
                <div className="">
                  <DateBox
                    className="SelectBoxDate mb-4"
                    placeholder="Fecha de reporte desde"
                    label="Desde"
                    onValueChanged={(e) =>
                      setFiltrosReporte({
                        ...FiltrosReporte,
                        fechaInicio: e.value,
                      })
                    }
                    defaultValue={fechaInicial}
                    value={fechaInicial}
                    type="date"
                  />
                </div>
              </div>

              <div className="dx">
                <div className="">
                  <DateBox
                    className="SelectBoxDate mb-4"
                    placeholder="Fecha de reporte hasta"
                    label="Hasta"
                    onValueChanged={(e) =>
                      setFiltrosReporte({
                        ...FiltrosReporte,
                        fechaFinal: e.value,
                      })
                    }
                    defaultValue={FechaFinal}
                    value={FechaFinal}
                    type="date"
                  />
                </div>
              </div>
              <div className="BTN">
                <Button
                  className="btnGenerarReporte"
                  variant="contained"
                  onClick={() => OnSubmit()}
                  size="large"
                >
                  Filtrar
                </Button>
              </div>
            </div>
          </ScrollView>
        </Popup>

        <Popup
          width={"700px"}
          height={"500px"}
          visible={showPopupDelete}
          onHiding={hideDeletePopup}
          showTitle={true}
          title="Eliminar informacion"
          showCloseButton={true}
        >
          <ScrollView width="100%" height="100%">
            <div className="form-container text-center">
              <div className="dx">
                <p>¿Seguro que desea eliminar este formulario?</p>
                <p>
                  <b>Importante</b> El borrado del formulario es permanente
                </p>
                <div className="btnContainer">
                  <Button
                    className="btnEliminar"
                    variant="contained"
                    onClick={() => onDelete()}
                    size="large"
                  >
                    Borrar
                  </Button>

                  <Button
                    className="btnEliminar"
                    variant="contained"
                    onClick={hideDeletePopup}
                    size="large"
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            </div>
          </ScrollView>
        </Popup>

        <Popup
          width={400}
          height={350}
          visible={showPopupEstabId}
          onHiding={() => setShowPopupEstabId(false)}
          showTitle={true}
          title="Cambiar establecimiento"
          showCloseButton={true}
        >
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <div className="mb-4">
              <label>Región</label>
              <SelectBox
                dataSource={regiones}
                valueExpr="nombre_region"
                displayExpr="nombre_region"
                value={regionSeleccionada}
                onValueChanged={(e) => {
                  setRegionSeleccionada(e.value);
                  setClienteSeleccionado(""); // Reiniciar si cambia
                  setEstablecimientoSeleccionado(""); // Reiniciar si cambia
                }}
                searchEnabled={true}
              />
            </div>

            <div className="mb-4">
              <label>Establecimientos</label>
              <SelectBox
                dataSource={establecimientosFiltrados}
                valueExpr="nombre_establecimiento"
                displayExpr={(item) =>
                  item && item.nombre_establecimiento
                    ? `${item.ID} - ${item.nombre_establecimiento}`
                    : ""
                }
                value={establecimientoSeleccionado}
                onValueChanged={(e) => {
                  setEstablecimientoSeleccionado(e.value);
                }}
                searchEnabled={true}
                placeholder="Seleccione un establecimiento"
              />
            </div>
            <Button
              className="btn btn-primary mt-3 mr-2"
              onClick={ModifyEstablecimientos}
              disabled={!regionSeleccionada || !establecimientoSeleccionado}
            >
              Guardar Cambios
            </Button>
            <Button
              className="btn btn-secundary mt-3"
              onClick={() => setShowPopupEstabId(false)}
            >
              Cerrar
            </Button>
          </div>
        </Popup>
      </div>
    </div>
  );
}
